import { render, staticRenderFns } from "./PeerSupportSettings.vue?vue&type=template&id=7c23413a&scoped=true"
import script from "./PeerSupportSettings.vue?vue&type=script&lang=js"
export * from "./PeerSupportSettings.vue?vue&type=script&lang=js"
import style0 from "./PeerSupportSettings.vue?vue&type=style&index=0&id=7c23413a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c23413a",
  null
  
)

export default component.exports